import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Domain } from '@feathr/blackbox';
import { CardV2, Time } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';

import DomainField from './DomainField';

import * as styles from './DomainInfoCard.css';

interface IProps {
  domain: Domain;
}

function DomainInfoCard({ domain }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <CardV2 width={'full'}>
      <CardV2.Header title={t('Domain details')} />
      <CardV2.Content>
        <div className={styles.fields}>
          <DomainField
            label={t('Content serving subdomain')}
            tooltip={t('The subdomain used for serving links and landing pages in your campaigns.')}
          >
            {domain.get('content_domain')}
          </DomainField>
          <DomainField
            label={t('Email sending subdomain')}
            tooltip={t(
              'The subdomain used for sending emails, enabling proper authentication and deliverability.',
            )}
          >
            {domain.get('mail_from')}
          </DomainField>
          <DomainField
            label={t('DNS host')}
            tooltip={t("The registrar or DNS provider where your domain's records are managed.")}
          >
            {domain.get('dns_provider')}
          </DomainField>
          <DomainField label={t('Date added')}>
            <Time format={TimeFormat.longDate} timestamp={domain.get('date_created')} />
          </DomainField>
        </div>
      </CardV2.Content>
    </CardV2>
  );
}

export default observer(DomainInfoCard);
